export default __webpack_public_path__ + "1621b6dee3f1242daa098eff9466005d.png";